import { render, staticRenderFns } from "./editBtn.vue?vue&type=template&id=08d55a01&scoped=true"
import script from "./editBtn.vue?vue&type=script&lang=js"
export * from "./editBtn.vue?vue&type=script&lang=js"
import style0 from "./editBtn.vue?vue&type=style&index=0&id=08d55a01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d55a01",
  null
  
)

export default component.exports